export interface IPopupProps {
    children: React.ReactNode;
    className?: string;
    onClose: () => void;
    //size: 'sm' | 'md' | 'lg' | 'max';
    isPopupOpen?: boolean;
    msgType?: string;
}

export type TPopupComponent = Omit<IPopupProps, 'onClose'>;

export interface IState {
    errorMessage?: {
        code: number;
        subCode: number;
        message: string;
        type: string;
        description: string;
    };
    messageType?: string;
    freeSpinsRead?: boolean;
    freeSpinsAmount: number;
}

export enum EMessagesTypes {
    error = 'errorMessage',
    freeSpins = 'freeSpins',
    rgsMesssage = 'rgsMesssage',
    insufficientFunds = 'insufficientFunds',
    logoutConfirmation = 'logoutConfirmation'
}
